import Vue from 'vue'
import Router from 'vue-router'
import homeView from '../views/home.vue'
import pepiteView from '../views/pepite.vue'
import newslettersView from '../views/newsletter.vue'
import faqView from '../views/faq.vue'
import documentsView from '../views/documents.vue'
import greenScoreView from '../views/greenScore.vue'
import webmasterToolsView from '../views/webmasterTools.vue'
import bookingsView from '../views/bookings.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: homeView
    },
    {
      path: '/pepite',
      name: 'pepite',
      component: pepiteView
    },
    {
      path: '/newsletters',
      name: 'newsletters',
      component: newslettersView
    },
    {
      path: '/faq',
      name: 'faq',
      component: faqView
    },
    {
      path: '/greenscore',
      name: 'greenscore',
      component: greenScoreView
    },
    {
      path: '/documents',
      name: 'documents',
      component: documentsView
    },
    {
      path: '/webmastertools',
      name: 'webmastertools',
      component: webmasterToolsView
    },
    {
      path: '/bookings',
      name: 'bookings',
      component: bookingsView
    }
  ]
})
